export default __webpack_public_path__ + "static/media/Maestro.a613e89b.svg";